export const CODES_POSTAUX_DROM = ['971', '972', '973', '974'] as const
export const CODES_POSTAUX_UNIQUE = ['97133', '97150', '976', '975'] as const

export const SMIC_HOR_BRUTE = parseFloat(import.meta.env.VITE_DEMANDE_SMIC_HOR_BRUTE)
